import { createSlice } from "@reduxjs/toolkit";
import {
  plan,
  savePlan,
  region,
  list,
  tracking,
  savePersonal,
  trackingUpdate,
  getPersonal,
  getAllDetails,
  saveSecurity,
  getSecurity,
  journeyUpdate,
  nomineeMasterApi,
  hdfcRegion,
  Ckyc,
} from "./serviceApi";
import { load_user } from "../plans/plans.slice";

export const detailsform = createSlice({
  name: "detailsform",
  initialState: {
    response: {},
    savePlanresponse: {},
    regionresponse: {},
    hdfcRegionresponse: {},
    hdfcRegionresponseNominee: {},
    hdfcRegionresponseAppointee: {},
    relation_responce: {},
    occupation_responce: {},
    annualincome_responce: {},
    sourcefund_responce: {},
    devices_responce: {},
    regionresponse2: {},
    listresponse: {},
    trackingresponse: {},
    alert: null,
    personal: {},
    loading: null,
    security: {},
    personalResponse: null,
    pincodeLoading: false,
    ckycLoading: false,

    ckycFailCount: 0,
    isCkycSuccess: false,
    ckycId: "",
  },

  //reducers
  reducers: {
    isPincodeLoading: (state, { payload }) => {
      state.pincodeLoading = payload;
    },

    planDetails: (state, action) => {
      state.response = action.payload;
    },

    savePlanDetails: (state, action) => {
      state.savePlanresponse = action.payload;
      state.loading = null;
    },
    regionDetails: (state, action) => {
      state.regionresponse = action.payload;
    },
    hdfcRegionDetails: (state, action) => {
      state.hdfcRegionresponse = action.payload;
    },
    hdfcRegionDetailsNominee: (state, action) => {
      state.hdfcRegionresponseNominee = action.payload;
    },
    hdfcRegionDetailsAppointee: (state, action) => {
      state.hdfcRegionresponseAppointee = action.payload;
    },

    relationDetails: (state, action) => {
      state.relation_responce = action.payload;
    },
    occupationDetails: (state, action) => {
      state.occupation_responce = action.payload;
    },

    annualIncomeDetails: (state, action) => {
      state.annualincome_responce = action.payload;
    },
    sourceOfFundDetails: (state, action) => {
      state.sourcefund_responce = action.payload;
    },
    deviceDetails: (state, action) => {
      state.devices_responce = action.payload;
    },

    regionDetails2: (state, action) => {
      state.regionresponse2 = action.payload;
    },
    clearRegionDetails: (state) => {
      state.regionresponse = {};
    },
    clearRegionDetailsHdfc: (state) => {
      state.hdfcRegionresponse = {};
    },
    clearRegionDetailsHdfcNominee: (state) => {
      state.hdfcRegionresponseNominee = {};
    },
    clearRegionDetailsHdfcAppointee: (state) => {
      state.hdfcRegionresponseAppointee = {};
    },
    clearRegionDetails2: (state) => {
      state.regionresponse2 = {};
    },
    listDetails: (state, action) => {
      state.listresponse = action.payload;
    },
    trackLog: (state, action) => {
      state.trackingresponse = action.payload;
    },
    alertMessage: (state, action) => {
      state.alert = action.payload;
    },
    clearAlertMessage: (state, action) => {
      state.alert = null;
    },
    loading: (state, action) => {
      state.loading = true;
    },
    clearLoading: (state, action) => {
      state.loading = null;
    },
    personalDetails: (state, { payload }) => {
      state.personal = payload;
    },
    allDetails: (state, { payload }) => {
      state.allDetails = payload;
    },
    personalResponse: (state, { payload }) => {
      state.personalResponse = payload;
    },
    securityDetails: (state, { payload }) => {
      state.security = payload;
    },
    setCkycFailCount: (state, { payload }) => {
      state.ckycFailCount = state.ckycFailCount + 1;
    },
    setCkycSuccess: (state, { payload }) => {
      state.isCkycSuccess = payload;
    },
    setCkycId: (state, { payload }) => {
      state.ckycId = payload;
    },
    isCkycLoading: (state) => {
      state.ckycLoading = true;
    },
  },
});

export const {
  planDetails,
  personalDetails,
  alertMessage,
  clearAlertMessage,
  savePlanDetails,
  regionDetails,
  relationDetails,
  occupationDetails,
  annualIncomeDetails,
  sourceOfFundDetails,
  deviceDetails,
  regionDetails2,
  clearRegionDetails,
  hdfcRegionDetails,
  hdfcRegionDetailsNominee,
  hdfcRegionDetailsAppointee,
  clearRegionDetailsHdfc,
  clearRegionDetailsHdfcNominee,
  clearRegionDetailsHdfcAppointee,
  clearRegionDetails2,
  listDetails,
  trackLog,
  loading,
  clearLoading,
  allDetails,
  personalResponse,
  securityDetails,
  isPincodeLoading,
  isCkycLoading,
  setCkycFailCount,
  setCkycSuccess,
  setCkycId,
} = detailsform.actions;
//CKYC
export const getCkyc = ({
  ic_id,
  pan_no,
  mode,
  type,
  company_alias,
  ...additonaldata
}) => {
  return async (dispatch, getState) => {
    const query = new URLSearchParams(window.location.search);
    const enquiry_id = query.get("enquiry_id");

    const response = await Ckyc({
      ic_id,
      pan_no,
      mode,
      type,
      enquiry_id,
      company_alias,
      section: "cyber",
      ...additonaldata,
    });

    if (ic_id * 1 === 1) {
      if (!response?.data?.data?.verification_status) {
        dispatch(setCkycFailCount());
      } else {
        dispatch(setCkycSuccess(true));
        dispatch(setCkycId(response?.data?.data?.data?.ckyc_id));
      }
    }
  };
};

//action Creators
export const planData = (data, ...otherData) => {
  return async (dispatch) => {
    try {
      const response = await plan(data);
      console.log("response", response);
      if (response?.data) {
        dispatch(planDetails(response));
      } else {
        dispatch(alertMessage(response?.message || "Something went wrong"));
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};

export const savePlanData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(loading());
      const savePlanresponse = await savePlan(data);
      if (savePlanresponse?.data) {
        dispatch(savePlanDetails(savePlanresponse));
      } else if (!savePlanresponse?.status) {
        dispatch(
          alertMessage(savePlanresponse?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};

export const getRegion = (data) => {
  return async (dispatch) => {
    try {
      const regionresponse = await region(data);
      if (regionresponse?.data) {
        dispatch(regionDetails(regionresponse));
      } else {
        dispatch(
          alertMessage(regionresponse?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getRegionHdfc = (data) => {
  return async (dispatch) => {
    try {
      dispatch(isPincodeLoading(true));
      const regionresponse = await hdfcRegion(data);
      if (regionresponse?.data) {
        dispatch(hdfcRegionDetails(regionresponse));
        dispatch(isPincodeLoading(false));
      } else {
        dispatch(isPincodeLoading(false));
        dispatch(
          alertMessage(regionresponse?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getRegionHdfcNominee = (data) => {
  return async (dispatch) => {
    try {
      dispatch(isPincodeLoading(true));
      const regionresponse = await hdfcRegion(data);
      if (regionresponse?.data) {
        dispatch(hdfcRegionDetailsNominee(regionresponse));
        dispatch(isPincodeLoading(false));
      } else {
        dispatch(
          alertMessage(regionresponse?.message || "Something went wrong")
        );
        dispatch(isPincodeLoading(false));
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getRegionHdfcAppointee = (data) => {
  return async (dispatch) => {
    try {
      dispatch(isPincodeLoading(true));
      const regionresponse = await hdfcRegion(data);
      if (regionresponse?.data) {
        dispatch(hdfcRegionDetailsAppointee(regionresponse));
        dispatch(isPincodeLoading(false));
      } else {
        dispatch(
          alertMessage(regionresponse?.message || "Something went wrong")
        );
        dispatch(isPincodeLoading(false));
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getRelationDetails = (data) => {
  return async (dispatch) => {
    try {
      const relationResponce = await nomineeMasterApi(data);
      if (relationResponce?.data) {
        dispatch(relationDetails(relationResponce));
      } else {
        dispatch(
          alertMessage(relationResponce?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getOccupationDetails = (data) => {
  return async (dispatch) => {
    try {
      const relationResponce = await nomineeMasterApi(data);
      if (relationResponce?.data) {
        dispatch(occupationDetails(relationResponce));
      } else {
        dispatch(
          alertMessage(relationResponce?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getAnnualIncomeDetails = (data) => {
  return async (dispatch) => {
    try {
      const relationResponce = await nomineeMasterApi(data);
      if (relationResponce?.data) {
        dispatch(annualIncomeDetails(relationResponce));
      } else {
        dispatch(
          alertMessage(relationResponce?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getSourceOfFundDetails = (data) => {
  return async (dispatch) => {
    try {
      const relationResponce = await nomineeMasterApi(data);
      if (relationResponce?.data) {
        dispatch(sourceOfFundDetails(relationResponce));
      } else {
        dispatch(
          alertMessage(relationResponce?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};
export const getDeviceDetails = (data) => {
  return async (dispatch) => {
    try {
      const relationResponce = await nomineeMasterApi(data);
      if (relationResponce?.data) {
        dispatch(deviceDetails(relationResponce));
      } else {
        dispatch(
          alertMessage(relationResponce?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};

export const getRegion2 = (data) => {
  return async (dispatch) => {
    try {
      const regionresponse = await region(data);
      if (regionresponse?.data) {
        dispatch(regionDetails2(regionresponse));
      } else {
        dispatch(
          alertMessage(regionresponse?.message || "Something went wrong")
        );
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};

export const getList = () => {
  return async (dispatch) => {
    try {
      const listresponse = await list();
      if (listresponse?.data) {
        dispatch(listDetails(listresponse));
      } else {
        dispatch(alertMessage(listresponse?.message || "Something went wrong"));
      }
    } catch (err) {
      dispatch(alertMessage("Something went wrong"));
    }
  };
};

export const trackProgress = (data) => {
  return async (dispatch) => {
    try {
      const trackingresponse = await tracking(data);
      if (trackingresponse?.data) {
        dispatch(trackLog(trackingresponse));
      } else {
        console.error("Tracking failed");
      }
    } catch (err) {
      console.error("Tracking failed");
    }
  };
};

export const savePersonalDetails = (data) => {
  return async (dispatch) => {
    try {
      const response = await savePersonal(data);
      dispatch(personalResponse(response));
      if (data.fname)
        dispatch(
          load_user({
            firstname: data.fname,
            lastname: data.lname,
            mobile_no: data.mobile_no,
            email: data.email,
          })
        );
    } catch (error) {
      console.error(error);
    }
  };
};

export const saveSecurityDetails = (data) => {
  return async (dispatch) => {
    try {
      await saveSecurity(data);
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateProgress = (data) => {
  return async (dispatch) => {
    try {
      const trackingresponse = await trackingUpdate(data);
      if (trackingresponse?.data) {
        dispatch(trackLog(trackingresponse));
      } else {
        console.error("Tracking failed");
      }
    } catch (err) {
      console.error("Tracking failed");
    }
  };
};

export const getSecurityDetails = (data) => {
  return async (dispatch) => {
    try {
      const response = await getSecurity(data);
      if (response?.data) dispatch(securityDetails(response));
    } catch (err) {
      console.error("Failed to get Details");
    }
  };
};

export const getPers = (data) => {
  return async (dispatch) => {
    try {
      const response = await getPersonal(data);
      if (response?.data) dispatch(personalDetails(response));
    } catch (err) {
      console.error("Failed to get Details");
    }
  };
};
export const getAll = (data) => {
  return async (dispatch) => {
    try {
      const response = await getAllDetails(data);
      if (response?.data) dispatch(allDetails(response));
    } catch (err) {
      console.error("Failed to get Details");
    }
  };
};

// journey update
export const updateJourney = (data) => {
  return async (dispatch) => {
    try {
      journeyUpdate(data);
    } catch (err) {
      console.error("Failed to get Details", err);
    }
  };
};

//reducer export
export default detailsform.reducer;
